import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { FormField, ThemeConfig } from '../../../types/forms';
import { normalizeFieldOption } from '../../../types/forms';
import { getInputStyles } from '../../../lib/themeUtils';
import { useScrollIntoViewOnFocus } from '../../../hooks/useScrollIntoViewOnFocus';

interface SelectFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  field,
  value = '',
  onChange,
  error,
  disabled,
  themeConfig,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputStyles = getInputStyles(themeConfig, { error: !!error, focused: isFocused });
  const scrollOnFocus = useScrollIntoViewOnFocus<HTMLSelectElement>();

  return (
    <div className="relative min-w-0 max-w-full">
      <select
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={(e) => { setIsFocused(true); scrollOnFocus(e); }}
        onBlur={() => setIsFocused(false)}
        required={field.required}
        disabled={disabled}
        className="w-full min-w-0 max-w-full px-4 py-3 pr-12 focus:outline-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed appearance-none cursor-pointer"
        style={inputStyles}
      >
        <option value="" disabled style={{ backgroundColor: inputStyles.backgroundColor || '#171717', color: inputStyles.color }}>
          {field.placeholder || 'Selecione uma opção'}
        </option>
        {field.options?.map((rawOption) => {
          const opt = normalizeFieldOption(rawOption);
          return (
            <option key={opt.value} value={opt.value} style={{ backgroundColor: inputStyles.backgroundColor || '#171717', color: inputStyles.color }}>
              {opt.label}
            </option>
          );
        })}
      </select>
      <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: inputStyles.color, opacity: 0.5 }}>
        <ChevronDown className="w-5 h-5" />
      </div>
    </div>
  );
};
